import React, { useRef, useState, useEffect } from "react";
import {
  getStoreList,
  updateActiveStatus,
} from "../../services/store.services";
import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CFormLabel,
  CFormInput,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPlus } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import Switch from "react-switch";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { getActiveCountryList } from "src/services/country.services";
import { BsChevronDoubleDown, BsChevronDoubleUp } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { getSearchAbleRoutes } from "src/services/route.services";

const StoreManagementTable = () => {
  const [localUser, setLocalUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [selectedRouteOption, setSelectedRouteOption] = useState("");
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const statusOptions = [
    {
      value: "true",
      label: "Active",
    },
    {
      value: "false",
      label: "Inactive",
    },
  ];

  const { register, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      locationCode: "",
      address: "",
      city: "",
      state: "",
    },
  });

  useEffect(() => {
    if (localUser && localUser.userType === "superAdmin") getActiveCountries();
    getStoreItem(currentPage);
    getRouteNameList(null);
  }, []);

  useEffect(() => {
    if (
      localUser &&
      localUser.userType === "superAdmin" &&
      selectedCountry &&
      selectedCountry.value
    ) {
      getStoreItem(currentPage, selectedCountry.value);
    } else {
      getStoreItem(currentPage);
    }
  }, [selectedCountry]);

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getStoreItem = (page, country = "", searchParmas = null) => {
    setIsLoading(true);
    getStoreList({ limit, page, country, searchParmas })
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const getRouteNameList = (country, searchString = "") => {
    getSearchAbleRoutes({ country, searchString })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];

        fetchedRouteData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
        });

        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  const handleStatusChange = (checked, id) => {
    const data = {
      isActive: checked,
    };
    toast
      .promise(
        updateActiveStatus(data, id),
        {
          loading: "Loading",
          success: "Status updated Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        getStoreItem(currentPage);
      })
      .catch((error) => console.error(error));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    const data = getValues();
    let searchParmas = {
      ...data,
      route: selectedRouteOption ? selectedRouteOption.value : "",
      country: selectedCountry ? selectedCountry.value : "",
      isActive: selectedStatus ? selectedStatus : "",
    };
    getStoreItem(newPage, null, searchParmas);
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setCurrentPage(1);
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
  };

  const onFormSubmit = (data) => {
    console.log(selectedStatus);
    setCurrentPage(1);
    let searchParmas = {
      ...data,
      route: selectedRouteOption ? selectedRouteOption.value : "",
      country: selectedCountry ? selectedCountry.value : "",
      isActive: selectedStatus ? selectedStatus : "",
    };
    getStoreItem(1, null, searchParmas);
  };
  const handleReset = () => {
    console.log("reseting form");
    reset({
      name: "",
      locationCode: "",
      address: "",
      city: "",
      state: "",
    });
    setSelectedCountry("");
    setSelectedStatus("");
    setSelectedRouteOption("");
  };

  const handleChangeRoute = (selectedOption) => {
    if (selectedOption) {
      setSelectedRouteOption(selectedOption);
    } else {
      setSelectedRouteOption("");
    }
  };

  const handleOnInputChangeRoute = (searchValue) => {
    if (searchValue) {
      const matchingRoutes = routeOptions.filter((route) =>
        route.label.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (matchingRoutes.length <= 0) {
        getRouteNameList(selectedCountry?.value, searchValue);
      }
    }
  };

  const handleSelectStatus = (selectedOption) => {
    if (selectedOption) {
      setSelectedStatus(selectedOption.value);
    } else {
      setSelectedStatus("");
    }
  };
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <div className="position-absolute p-2 top-0 end-0">
            <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={() => setShowAdditionalFields((prev) => !prev)}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton>
          </div>
          <CRow className="mb-3">
            <CCol xs={12} md={3} className="mb-2">
              <CFormLabel>Name</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type Store/Location name"
                {...register("name", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Location Code</CFormLabel>
              <CFormInput
                type="text"
                placeholder="The location code"
                {...register("locationCode", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Address</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type address"
                {...register("address", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>City</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type city name"
                {...register("city", { required: false })}
              />
            </CCol>
          </CRow>
          <div
            style={{
              maxHeight: showAdditionalFields ? "100%" : "0",
              transition: "max-height 0.5s ease",
            }}
          >
            {showAdditionalFields && (
              <CRow className="mb-4">
                <CCol xs={12} md={3}>
                  <CFormLabel>State</CFormLabel>
                  <CFormInput
                    type="text"
                    placeholder="Type state name"
                    {...register("state", { required: false })}
                  />
                </CCol>
                {localUser && localUser.userType === "superAdmin" && (
                  <CCol xs={12} md={3}>
                    <CFormLabel>Country:</CFormLabel>

                    <ReactSelect
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={countrySelectOptions}
                      isClearable={true}
                    />
                  </CCol>
                )}
                <CCol xs={12} md={3}>
                  <CFormLabel>Route Name:</CFormLabel>
                  <ReactSelect
                    value={selectedRouteOption}
                    onChange={handleChangeRoute}
                    onInputChange={handleOnInputChangeRoute}
                    options={routeOptions}
                    isClearable={true}
                  />
                </CCol>

                <CCol sm={3}>
                  <CFormLabel>Status:</CFormLabel>
                  <ReactSelect
                    value={selectedStatus.value}
                    options={statusOptions}
                    onChange={handleSelectStatus}
                    isClearable={true}
                  />
                </CCol>
              </CRow>
            )}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit(onFormSubmit)}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow sm={{ gutter: 4 }} md={{ gutter: 4 }}>
            <CCol sm={12} md={5}>
              <h4 id="traffic" className="card-title mb-0">
                Location Management - Total: {count}
              </h4>
            </CCol>
            <CCol sm={12} md={7}>
              <div className="d-flex  justify-content-sm-start justify-content-md-end gap-4">
                {localUser && localUser.userType === "superAdmin" && (
                  <div className="w-25">
                    <ReactSelect
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={countrySelectOptions}
                      isClearable={true}
                      placeholder="Country"
                    />
                  </div>
                )}
                <Link to="/create-bulk-store" className="w-auto">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Upload Location Data
                  </CButton>
                </Link>
                <Link to="/create-store" className="w-auto">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Create Location
                  </CButton>
                </Link>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable
            align="middle"
            className="mb-0 border text-center"
            hover
            responsive
          >
            <CTableHead color="light">
              <CTableRow>
                {/* <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell> */}
                <CTableHeaderCell className="text-center">
                  Active Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Location Code
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Name
                </CTableHeaderCell>
                {/* <CTableHeaderCell>Latitude</CTableHeaderCell>
                <CTableHeaderCell>Longitude</CTableHeaderCell> */}
                <CTableHeaderCell className="text-center">
                  Address
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  City
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  State
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Country
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Route
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="10">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="10">
                    No data available
                  </CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>
                      <Switch
                        size="sm"
                        onChange={(checked, id) =>
                          handleStatusChange(checked, item._id)
                        }
                        checked={item.isActive}
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <Link to={`/edit-store/${item._id}`}>
                        <CButton
                          size="sm"
                          color="secondary"
                          style={{ color: "white" }}
                        >
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell>{item.locationCode}</CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.name}
                    </CTableDataCell>
                    {/* <CTableDataCell>
                     {item.latitude}
                  </CTableDataCell>
                  <CTableDataCell>
                     {item.longitude}
                  </CTableDataCell> */}
                    <CTableDataCell>{item.address}</CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.city}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.state}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.country?.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.route ? item.route.name : "Not Assigned"}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
    </>
  );
};

export default StoreManagementTable;
